/**
 * ログインに失敗してトップ (/) に戻されたときの ?error= コードを、利用者向けの文言にする。
 *
 * コードの発生元: src/app/api/auth/freee/callback/route.ts / src/lib/auth/freeeAuth.ts /
 * src/app/auth/callback/page.tsx。文言は使い方ガイドの「ログインできないとき」と一致させること。
 */
export const LOGIN_ERROR_MESSAGES: ReadonlyMap<string, string> = new Map([
  // freee 人事労務の users/me に事業所・従業員 ID が無い (従業員として未登録 / 未連携)
  [
    "no_company",
    "freee 人事労務の従業員情報が見つかりませんでした。会社の管理者にお問い合わせください。",
  ],
  // freee から認可コードが返らなかった (連携を許可せずに戻った等)
  [
    "no_code",
    "freee での連携が完了しませんでした。もう一度ログインし、連携を許可してください。",
  ],
  // マジックリンクの期限切れ・使用済み
  ["link_expired", "ログインの有効期限が切れました。もう一度ログインしてください。"],
]);

export const LOGIN_ERROR_FALLBACK_MESSAGE =
  "ログインできませんでした。時間をおいてもう一度お試しください。";

/** エラーコードが無ければ null。未知のコードは汎用の文言にする */
export function getLoginErrorMessage(code: string | null): string | null {
  if (!code) return null;
  return LOGIN_ERROR_MESSAGES.get(code) ?? LOGIN_ERROR_FALLBACK_MESSAGE;
}
